import { db } from '@smart-maps/firebase';

import { APP_MAP_ID, EVENT_TYPES } from '../../constants';

export const importTodos = (payload, user) => async dispatch => {
  dispatch({ type: EVENT_TYPES.LOADING_START });
  if (user && user.uid) {
    const path = `${APP_MAP_ID}/done`;
    await db.commit(user.uid, path, payload);
  }
  dispatch({
    payload,
    type: EVENT_TYPES.TODO_IMPORT,
  });
};

export const toggleTodo = (id, user) => async (dispatch, getState) => {
  const previous = getState().done;
  const found = previous.find(checked => checked === id);
  const next = !found
    ? [...previous, id]
    : previous.filter(checked => checked !== id);
  dispatch({ type: EVENT_TYPES.LOADING_START });
  if (user && user.uid) {
    const path = `${APP_MAP_ID}/done`;
    await db.commit(user.uid, path, next);
  }
  dispatch({
    payload: next,
    type: EVENT_TYPES.TODO_TOGGLE,
  });
};
